import {
  type GenericHttpResult,
  type ApiOrganization,
  ApiItemTypes,
  ApiAssetType,
} from '@agunity/api-v4';
import { apiService } from '../../../api/apiService';

export const getOrganizationItem = (orgId: number) => {
  return async (): Promise<GenericHttpResult<ApiOrganization>> => {
    const response = await apiService.organizationV20ItemDetail(orgId);
    return response;
  };
};

export const getOrgImage = (imageId: number) => {
  return async (): Promise<GenericHttpResult<string>> => {
    const response = await apiService.blobV30Base64Detail(ApiItemTypes.Organization, imageId);
    return response;
  };
};

// Get all asset types
export const getAssetTypesList = () => {
  return async (): Promise<GenericHttpResult<ApiAssetType[]>> => {
    const response = await apiService.assetTypeV20ListList();
    return response;
  };
};

// Get all selected ids
export const getAssetTypesAssociatedIds = (orgId: number) => {
  return async (): Promise<GenericHttpResult<number[]>> => {
    const response = await apiService.organizationV10AssetTypesAssociatedDetail(orgId);
    return response;
  };
};

export const patchOrganizationItem = (orgId: number, data: ApiOrganization) => {
  return async (): Promise<GenericHttpResult<number>> => {
    const response = await apiService.organizationV20ItemPartialUpdate(orgId, data);
    return response;
  };
};